import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/tarefas',
    name: 'tasks',
    redirect: '/tarefas/geral',
    meta: {
      can_show: FEATURES.TASKS,
      search: {
        title: 'Tarefas',
        description: 'Calendário de tarefas e eventos do escritório',
        keywords: [
          'tarefas',
          'calendário',
          'eventos',
          'agenda',
          'compromissos',
        ],
        icon: 'mdi-calendar-outline',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@src/modules/calendar/views/nav-bar/view-nav-bar.vue')
      ),
    children: [
      {
        path: 'geral',
        name: 'tasks.overview',
        meta: {
          can_show: FEATURES.TASKS,
        },
        component: () =>
          lazyLoadView(
            import('@modules/calendar/views/calendar/view-calendar.vue')
          ),
      },
    ],
  },
]
